import api from "./api";
import { toast } from "react-toastify";

class PatientService {
  getCancelTokenSource() {
    return api.CancelToken.source();
  }
  cancelRequest(source) {
    source.cancel();
  }
  async getPatientUser(kapid_id, abortContoller) {
    try {
      if (abortContoller === undefined) {
        abortContoller = new AbortController();
      }
      const response = await api
        .get(`/patient/${kapid_id}/`, { signal: abortContoller.signal })
        .then((res) => res.data);
      if (response.success) {
        const user = response.response;
        return user;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);

      // console.log(ex);
      return false;
    }
  }

  async searchService(q) {
    try {
      const response = await api
        .get(`/services/search/?query=${q}`)
        .then((res) => res.data);
      if (response.success) {
        const services = response.response;
        return services;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      return false;
    }
  }

  async processServiceOrder(data) {
    try {
      var endpoint = data.bp_service_order_base_id
        ? "/services/update-order/"
        : "/services/new-order/";
      // console.log(data);
      const response = await api.post(endpoint, data).then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
  async getOrder(orderid, kapid_id) {
    try {
      const response = await api
        .get(`/services/get-order/${kapid_id}/${orderid}/`)
        .then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
  async getInvoice(kapid_id, invoice_id) {
    try {
      const response = await api
        .get(`/patient/${kapid_id}/invoice/${invoice_id}/`)
        .then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }

  async getBranchServiceSchedule(source_id, bp_branch_id) {
    try {
      const response = await api
        .get(`/services/branch-service-schedule/${source_id}/`, {
          params: { bp_br_id: bp_branch_id },
        })
        .then((res) => res.data);
      if (response.success) {
        const events = response.response;
        if (events && events) {
          var eventList = [];
          events.forEach((event) => {
            eventList = [...eventList, ...event.bp_activity_schedule];
          });
          return eventList;
        }
        return [];
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
  async bookActivity(data) {
    try {
      const response = await api
        .post("/services/service-booking/", data)
        .then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
  async patientList(
    page = null,
    per_page = null,
    sorting_column = null,
    sorting_direction = null,
    search_text = null
  ) {
    try {
      const response = await api
        .get("/patient/all/", {
          params: {
            page: page,
            per_page: per_page,
            sorting_column: sorting_column,
            sorting_direction: sorting_direction,
            search_text: search_text,
          },
        })
        .then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
}

const patientService = new PatientService();
export default patientService;
